(function () {
  var productHandle = location.pathname.split("/products/")[1]?.split(/[?#/]/)[0] || "";
  if (!productHandle) return;

  function isVisualProductPage() {
    var body = document.body;
    if (body && (body.classList.contains("la-lighting-template-active") || body.classList.contains("la-led-display-template-active"))) {
      return true;
    }
    var context = [document.title || "", productHandle].join(" ").toLowerCase();
    return /\b(moving head|stage light|par light|strobe|laser light|waterproof light|led display|led screen|special effect)\b/.test(context);
  }

  if (isVisualProductPage()) return;

  function applyNx915MultiPurposeHeader() {
    if (productHandle !== "nx-912-sma-active-12-inch-active-multi-purpose-professional-speaker-with-built-in-6-channel-digital-mixer-touch-screen-and-bluetooth" && productHandle !== "nx-915-sma-active-15-inch-active-multi-purpose-professional-speaker-with-built-in-6-channel-digital-mixer-touch-screen-and-bluetooth") return;
    var apply = function () {
      var main = document.querySelector(".shopify-section--main-product") || document.querySelector("main");
      if (!main) return;
      var eyebrow = main.querySelector(".la-product-eyebrow");
      if (eyebrow) {
        var spans = eyebrow.querySelectorAll("span");
        if (spans.length >= 2) spans[1].textContent = "Multi-Purpose Speaker";
      }
      var description = main.querySelector(".product-info__description");
      if (description) {
        var copy = productHandle === "nx-912-sma-active-12-inch-active-multi-purpose-professional-speaker-with-built-in-6-channel-digital-mixer-touch-screen-and-bluetooth"
          ? "ART 912-AX is a compact 12-inch active portable PA speaker built for live sound, presentations, mobile events, houses of worship, entertainment venues and fixed installations. It combines 2100 W peak Class-D bi-amplification, precision DSP, a built-in 6-channel digital mixer, touch screen and Bluetooth support in one professional cabinet."
          : "ART 915-AX is a high-output 15-inch active portable PA speaker for live sound, DJs, bands, mobile events, venues and installed sound systems. It combines 2100 W peak Class-D bi-amplification, precision DSP, a built-in 6-channel digital mixer, touch screen and Bluetooth support for stronger full-range reinforcement.";
        description.innerHTML = "<p>" + copy + "</p>";
      }
    };
    apply();
    window.setTimeout(apply, 200);
    window.setTimeout(apply, 800);
    window.setTimeout(apply, 1600);
  }

  function injectVideoStyles() {
    if (document.getElementById("la-audio-video-product-styles")) return;
    var style = document.createElement("style");
    style.id = "la-audio-video-product-styles";
    style.textContent = [
      "html.la-audio-video-product body.la-audio-template-active .la-product-gallery-video-panels{display:grid!important;justify-items:center!important;gap:18px!important;margin-top:18px!important}",
      "html.la-audio-video-product body.la-audio-template-active .la-product-gallery-video-panel{display:grid!important;place-items:center!important;width:min(100%,720px)!important;max-width:720px!important;height:auto!important;min-height:0!important;aspect-ratio:var(--la-video-aspect,4/5)!important;margin:18px auto 0!important;overflow:hidden!important}",
      "html.la-audio-video-product body.la-audio-template-active .la-product-gallery-video-panel video{display:block!important;width:100%!important;max-width:720px!important;height:auto!important;max-height:none!important;min-height:0!important;aspect-ratio:var(--la-video-aspect,4/5)!important;object-fit:contain!important;margin:0 auto!important;background:#000!important}",
      "html.la-audio-video-product body.la-audio-template-active .shopify-section--main-product .product-gallery__media[data-media-type=video] video{display:block!important;width:min(100%,720px)!important;max-width:720px!important;height:auto!important;max-height:none!important;aspect-ratio:var(--la-video-aspect,4/5)!important;object-fit:contain!important;margin:0 auto!important}"
    ].join("");
    document.head.appendChild(style);
  }

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }
    callback();
  }

  document.documentElement.classList.add("la-audio-video-product");
  applyNx915MultiPurposeHeader();
  injectVideoStyles();

  var videoSources = null;
  var sourceRequestStarted = false;

  function productGalleryVideos() {
    return Array.from(document.querySelectorAll('.shopify-section--main-product .product-gallery__media[data-media-type="video"] video'));
  }

  function preferredVideoSource(sources) {
    var mp4 = (sources || []).filter(function (source) {
      return source && (source.mime_type === "video/mp4" || source.mimeType === "video/mp4");
    });
    var target = window.matchMedia("(max-width: 680px)").matches ? { width: 576, height: 720 } : { width: 864, height: 1080 };
    return mp4.find(function (source) {
      return Number(source.width) === target.width && Number(source.height) === target.height;
    }) || mp4.find(function (source) {
      return Number(source.width) === 576 && Number(source.height) === 720;
    }) || mp4.find(function (source) {
      return Number(source.width) === 864 && Number(source.height) === 1080;
    }) || mp4[0] || null;
  }

  function applyVideoAspect(video, sources, panel) {
    if (!video) return;
    var source = preferredVideoSource(sources || []);
    var width = Number(source && source.width) || Number(video.videoWidth);
    var height = Number(source && source.height) || Number(video.videoHeight);
    if (!width || !height) return;
    var aspect = width + "/" + height;
    video.style.setProperty("--la-video-aspect", aspect);
    if (panel) panel.style.setProperty("--la-video-aspect", aspect);
  }

  function setPreferredVideoSource(video, sources) {
    var source = preferredVideoSource(sources);
    applyVideoAspect(video, sources, video && video.closest(".la-product-gallery-video-panel"));
    if (!video || !source || !source.url) return;
    var sourceUrl = String(source.url).replace(/^\/\//, "https://");
    var currentSource = String(video.currentSrc || video.src || "").replace(/^\/\//, "https://").split("?")[0];
    if (video.dataset.laPreferredVideoSource === sourceUrl && currentSource === sourceUrl.split("?")[0]) return;
    var currentTime = Number.isFinite(video.currentTime) ? video.currentTime : 0;
    var wasPlaying = !video.paused;
    video.pause();
    video.removeAttribute("src");
    video.querySelectorAll("source").forEach(function (item) { item.remove(); });
    var element = document.createElement("source");
    element.src = sourceUrl;
    element.type = "video/mp4";
    video.appendChild(element);
    video.src = sourceUrl;
    video.dataset.laPreferredVideoSource = sourceUrl;
    video.dataset.laPreferredVideoWidth = String(source.width || "");
    video.dataset.laPreferredVideoHeight = String(source.height || "");
    video.load();
    video.addEventListener("loadedmetadata", function restorePlayback() {
      video.removeEventListener("loadedmetadata", restorePlayback);
      if (currentTime > 0 && currentTime < video.duration) video.currentTime = currentTime;
      if (wasPlaying) video.play().catch(function () {});
      applyVideoAspect(video, sources, video.closest(".la-product-gallery-video-panel"));
    });
  }

  function applyPreferredProductVideoSource() {
    productGalleryVideos().forEach(function (video, index) {
      setPreferredVideoSource(video, videoSources && videoSources[index] || []);
    });
    document.querySelectorAll(".la-product-gallery-video-panel video").forEach(function (video) {
      var index = Number(video.dataset.laVideoIndex || 0);
      setPreferredVideoSource(video, videoSources && videoSources[index] || []);
    });
  }

  function loadProductVideoSources() {
    if (videoSources || sourceRequestStarted) return;
    sourceRequestStarted = true;
    fetch(location.pathname.replace(/\/$/, "") + ".js", { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("product video data unavailable");
        return response.json();
      })
      .then(function (product) {
        videoSources = (product.media || []).filter(function (item) {
          return item.media_type === "video";
        }).map(function (item) {
          return item.sources || [];
        });
        applyPreferredProductVideoSource();
      })
      .catch(function () { videoSources = []; });
  }

  function removeLegacyProductVideoSections() {
    var legacyResourceSection = document.getElementById("la-product-videos");
    if (legacyResourceSection && !legacyResourceSection.querySelector(".la-product-gallery-video-panels")) {
      legacyResourceSection.remove();
    }
    document.querySelectorAll(".shopify-section--video, .la-product-inline-video-host, .la-product-inline-video-asset").forEach(function (section) {
      section.remove();
    });
  }

  function legacyProductVideoSections() {
    return Array.from(document.querySelectorAll(".shopify-section--video"));
  }

  function hideLegacyProductVideoSections() {
    document.querySelectorAll(".shopify-section--video").forEach(function (section) {
      section.hidden = true;
    });
  }

  function observeLegacyProductVideoSections() {
    var root = document.getElementById("main") || document.body;
    if (!root || root.dataset.laAudioLegacyVideoObserver === "true") return;
    root.dataset.laAudioLegacyVideoObserver = "true";
    var observer = new MutationObserver(function () {
      if (!productGalleryVideos().length) return;
      if (!document.querySelector(".shopify-section--video, .la-product-inline-video-host, .la-product-inline-video-asset")) return;
      removeLegacyProductVideoSections();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function showLegacyVideoPanel(nav, link) {
    if (productGalleryVideos().length) return false;
    var legacySections = legacyProductVideoSections();
    if (!legacySections.length) return false;
    legacySections.forEach(function (section) { section.hidden = false; });
    nav.querySelectorAll("[data-target]").forEach(function (item) {
      item.classList.toggle("is-active", item === link);
    });
    var firstVideo = legacySections[0].querySelector("video");
    if (firstVideo) {
      window.setTimeout(function () { firstVideo.play().catch(function () {}); }, 80);
    }
    var offset = Math.max(nav.getBoundingClientRect().height + 20, 92);
    window.scrollTo({ top: Math.max(legacySections[0].getBoundingClientRect().top + window.pageYOffset - offset, 0), behavior: "smooth" });
    return true;
  }

  function ensureVideoResourcePanel(nav) {
    var sourceVideos = productGalleryVideos();
    if (!sourceVideos.length) return null;
    removeLegacyProductVideoSections();
    var wrap = document.querySelector(".la-product-resource-sections");
    if (!wrap) {
      wrap = document.createElement("section");
      wrap.className = "la-product-resource-sections";
      wrap.setAttribute("aria-label", "Product resources");
      nav.after(wrap);
    }
    var section = document.getElementById("la-product-videos");
    if (!section) {
      section = document.createElement("section");
      section.className = "la-product-resource-section";
      section.id = "la-product-videos";
      section.innerHTML = '<h2>Videos / 产品视频</h2><div class="la-product-gallery-video-panels"></div>';
      wrap.appendChild(section);
    }
    var panels = section.querySelector(".la-product-gallery-video-panels");
    if (!panels) {
      panels = document.createElement("div");
      panels.className = "la-product-gallery-video-panels";
      section.appendChild(panels);
    }
    while (panels.children.length > sourceVideos.length) panels.lastElementChild.remove();
    sourceVideos.forEach(function (sourceVideo, index) {
      var panel = panels.children[index];
      if (!panel) {
        panel = document.createElement("div");
        panel.className = "la-product-gallery-video-panel";
        panel.innerHTML = '<video controls playsinline preload="metadata"></video>';
        panels.appendChild(panel);
      }
      var panelVideo = panel.querySelector("video");
      panelVideo.dataset.laVideoIndex = String(index);
      var sourceKey = sourceVideo.currentSrc || sourceVideo.src || Array.from(sourceVideo.querySelectorAll("source")).map(function (source) {
        return source.src;
      }).join("|");
      if (panelVideo.dataset.laGalleryVideoSource === sourceKey) return;
      panelVideo.pause();
      panelVideo.removeAttribute("src");
      panelVideo.querySelectorAll("source").forEach(function (source) { source.remove(); });
      var sources = Array.from(sourceVideo.querySelectorAll("source"));
      if (sources.length) {
        sources.forEach(function (source) {
          var clone = document.createElement("source");
          clone.src = source.src;
          if (source.type) clone.type = source.type;
          panelVideo.appendChild(clone);
        });
      } else if (sourceVideo.currentSrc || sourceVideo.src) {
        panelVideo.src = sourceVideo.currentSrc || sourceVideo.src;
      }
      panelVideo.poster = sourceVideo.getAttribute("poster") || "";
      panelVideo.dataset.laGalleryVideoSource = sourceKey;
      applyVideoAspect(sourceVideo, videoSources && videoSources[index] || [], sourceVideo.closest(".product-gallery__media"));
      applyVideoAspect(panelVideo, videoSources && videoSources[index] || [], panel);
      panelVideo.addEventListener("loadedmetadata", function () {
        applyVideoAspect(panelVideo, videoSources && videoSources[index] || [], panel);
      }, { once: true });
      panelVideo.load();
    });
    applyPreferredProductVideoSource();
    return section;
  }

  function showVideoPanel(nav, link) {
    loadProductVideoSources();
    var section = ensureVideoResourcePanel(nav);
    if (!section) return false;
    nav.querySelectorAll("[data-target]").forEach(function (item) {
      item.classList.toggle("is-active", item === link);
    });
    document.body.classList.add("la-resource-panel-active");
    document.querySelectorAll(".la-product-resource-section").forEach(function (item) {
      item.classList.toggle("is-current", item === section);
    });
    var firstVideo = section.querySelector(".la-product-gallery-video-panel video");
    if (firstVideo) {
      window.setTimeout(function () { firstVideo.play().catch(function () {}); }, 80);
    }
    var offset = Math.max(nav.getBoundingClientRect().height + 20, 92);
    window.scrollTo({ top: Math.max(section.getBoundingClientRect().top + window.pageYOffset - offset, 0), behavior: "smooth" });
    return true;
  }

  function initializeVideoUi() {
    if (productGalleryVideos().length) {
      removeLegacyProductVideoSections();
      observeLegacyProductVideoSections();
      window.__laShowAudioProductVideos = showVideoPanel;
      var nav = document.querySelector(".la-product-section-nav");
      var link = nav && nav.querySelector('[data-target="videos"]');
      if (nav) {
        ensureVideoResourcePanel(nav);
        link = nav.querySelector('[data-target="videos"]');
      }
      if (nav && link) {
        link.classList.remove("is-unavailable");
        link.setAttribute("aria-disabled", "false");
        bindVideoLink(link);
      }
    } else {
      window.__laShowAudioProductVideos = showLegacyVideoPanel;
    }
  }

  var boundVideoLinks = new WeakSet();
  var videoNavigationBound = false;

  function handleVideoNavigationClick(event, link) {
    if (!link || event.laAudioVideoHandled) return;
    var nav = link.closest(".la-product-section-nav");
    if (!nav) return;
    event.laAudioVideoHandled = true;
    event.preventDefault();
    event.stopImmediatePropagation();
    document.documentElement.dataset.laAudioVideoLastClick = productHandle;
    if (productGalleryVideos().length) {
      showVideoPanel(nav, link);
    } else {
      showLegacyVideoPanel(nav, link);
    }
  }

  function bindVideoLink(link) {
    if (!link || boundVideoLinks.has(link)) return;
    boundVideoLinks.add(link);
    link.addEventListener("click", function (event) {
      handleVideoNavigationClick(event, link);
    }, true);
  }

  function bindVideoNavigation() {
    if (videoNavigationBound) return;
    videoNavigationBound = true;
    window.addEventListener("click", function (event) {
      var link = event.target && event.target.closest && event.target.closest('.la-product-section-nav [data-target="videos"]');
      handleVideoNavigationClick(event, link);
    }, true);
  }

  function observeVideoNavigation() {
    var root = document.getElementById("main") || document.body;
    if (!root || root.dataset.laAudioVideoNavigationObserver === "true") return;
    root.dataset.laAudioVideoNavigationObserver = "true";
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        initializeVideoUi();
      });
    }).observe(root, { childList: true, subtree: true });
  }

  ready(function () {
    bindVideoNavigation();
    initializeVideoUi();
    observeVideoNavigation();
    [300, 900, 1800, 3200].forEach(function (delay) {
      window.setTimeout(initializeVideoUi, delay);
    });
  });
})();
